import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import axios from "axios";
import { Toaster } from "sonner";
import { Layout } from "./components/layout/Layout";
import { SeoManager } from "./components/common/SeoManager";
import { SiteDataProvider } from "./context/SiteData";
import AdminApp from "./admin/AdminApp";
import Home from "./pages/Home";
import Odalar from "./pages/Odalar";
import OdaDetay from "./pages/OdaDetay";
import Hizmetler from "./pages/Hizmetler";
import Videolar from "./pages/Videolar";
import Galeri from "./pages/Galeri";
import Konum from "./pages/Konum";
import Hakkimizda from "./pages/Hakkimizda";
import Iletisim from "./pages/Iletisim";
import Blog from "./pages/Blog";
import BlogDetay from "./pages/BlogDetay";
import NedenBiz from "./pages/NedenBiz";
import { API } from "./lib/api";


const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    // Bağlantı (anchor) varsa o bölüme yumuşak kaydır
    if (hash) {
      const t = setTimeout(() => {
        const el = document.getElementById(hash.slice(1));
        if (el) {
          if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
          else el.scrollIntoView({ behavior: "smooth" });
        }
      }, 150);
      return () => clearTimeout(t);
    }
    // Lenis aktifken window.scrollTo tek başına yeterli olmaz;
    // Lenis'in iç hedefi eski konumu geri yükleyebilir — ikisini birden sıfırla
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const VisitorTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    let sid = localStorage.getItem("yy_sid");
    if (!sid) {
      sid = crypto.randomUUID();
      localStorage.setItem("yy_sid", sid);
    }
    axios.post(`${API}/track`, { session_id: sid, path: pathname }).catch(() => {});
    const t = setInterval(() => {
      axios.post(`${API}/track`, { session_id: sid, path: window.location.pathname }).catch(() => {});
    }, 30000);
    return () => clearInterval(t);
  }, [pathname]);
  return null;
};

const useLenis = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
};

function App() {
  useLenis();
  return (
    <SiteDataProvider>
      <BrowserRouter>
        <ScrollManager />
        <VisitorTracker />
        <SeoManager />
        <Routes>
          <Route path="/admin" element={<AdminApp />} />
          <Route path="/admin/*" element={<AdminApp />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/odalar" element={<Odalar />} />
            <Route path="/odalar/:slug" element={<OdaDetay />} />
            <Route path="/hizmetler" element={<Hizmetler />} />
            <Route path="/videolar" element={<Videolar />} />
            <Route path="/galeri" element={<Galeri />} />
            <Route path="/konum" element={<Konum />} />
            <Route path="/hakkimizda" element={<Hakkimizda />} />
            <Route path="/nedenbiz" element={<NedenBiz />} />
            <Route path="/iletisim" element={<Iletisim />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetay />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
        <Toaster position="bottom-center" toastOptions={{ style: { borderRadius: "2px", background: "#0E0E0E", color: "#FDFBF7", border: "none" } }} />
      </BrowserRouter>
    </SiteDataProvider>
  );
}

export default App;
